import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Typography } from '@mui/material';

export default function ExpandableGrid({ data, active, loader, checkList }) {
  const [expandedRows, setExpandedRows] = React.useState(() =>
        data?.map((activity) => activity.activity_id) || []
        );
  const handleToggleExpand = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const rows = [];

  data.forEach((activity, index) => {
    const isExpanded = expandedRows.includes(activity.activity_id);
    rows.push({
      id: activity.activity_id,
      activity: activity.activity,
      weight: activity.weight,
      weight_decimal: activity.weight_decimal,
      part_id: activity.part_id,
      isParent: true,
      expanded: isExpanded,
    });

    if (isExpanded) {
      activity.sub_activity.forEach((sub, subIndex) => {
        rows.push({
          id: `sub-${sub.activity_id}`,
          activity: `${index + 1}.${subIndex + 1} ${sub.activity}`,
          weight: sub.weight,
          weight_decimal: sub.weight_decimal,
          part_id: sub.part_id,
          isParent: false,
        });
      });
    }
  });

  const columns = [
    {
      field: 'activity',
      headerName: 'Activity',
      flex: 1,
      sortable: false,
      filterable: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        const row = params.row;
        if (row.isParent) {
          return (
            <>
              <IconButton size="small" onClick={() => handleToggleExpand(row.id)}>
                {row.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
              <span>{row.activity}</span>
            </>
          );
        }
        return <span style={{ paddingLeft: 32 }}>{params.value}</span>;
      },
    },
    { 
        field: 'part_id', 
        headerName: 'Part ID', 
        flex: 1,
        sortable: false,
        filterable: true,
        disableColumnMenu: true,
        renderCell: (params) => {
            const row = params.row;
            const data = checkList?.find((item) => item?.id === row?.part_id);
            return <span >{data.part_name}</span>;
        },
    },

    { field: 'weight', headerName: 'Weight', flex: 1,  sortable: false, filterable: true, disableColumnMenu: true, },
    { field: 'weight_decimal', headerName: 'Weight Decimal', flex: 1,  sortable: false, filterable: true, disableColumnMenu: true, },
  ];

  return (
    <Box p={2} sx={{ height: 500, width: '100%' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
            <Typography fontSize={22} fontWeight={600}>
                {active}
            </Typography>
        </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        hideFooter
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
        loading={loader}
        sx={{
            '& .MuiDataGrid-columnSeparator': {
                color: '#fff',
            },
            '& .MuiDataGrid-columnHeader': {
              fontWeight: 600,
              backgroundColor: "#f16253",
              color: '#ffffff',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 600,
              width: '100%',
            }
          }}
      />
    </Box>
  );
}
